import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import Button from "@client/components/ui/Button";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 24px;

  > * {
    margin-bottom: 24px;
  }
`;
const Image = styled.div<{ image: any }>`
  width: 64px;
  height: 64px;
  background: url(${props => props.image}) center no-repeat;
  background-size: contain;
`;
const Message = styled.div``;

type Props = {
  image: any;
  message: string;
  buttonText: string;
  onButtonClick: () => void;
};

@observer
class DashboardEmpty extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        <Image image={this.props.image} />
        <Message>{this.props.message}</Message>
        <Button onClick={this.props.onButtonClick}>
          {this.props.buttonText}
        </Button>
      </Wrapper>
    );
  }
}

export default DashboardEmpty;
